import { render, staticRenderFns } from "./Discover.vue?vue&type=template&id=0b6b2122&scoped=true"
import script from "./Discover.vue?vue&type=script&lang=js"
export * from "./Discover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6b2122",
  null
  
)

export default component.exports